import { type ReactNode } from "react";
import { useAtomValue } from "jotai";

import { cn } from "shared/lib";

import { shouldShowValidationVar } from "@/components/treeModule/treeDialog/lib";

export interface FieldLabelProps {
  children: ReactNode;
  className?: string;
  isValid?: boolean;
}

export function FieldLabel({ children, className, isValid }: FieldLabelProps) {
  const shouldShowValidation = useAtomValue(shouldShowValidationVar);

  return (
    <label
      className={cn("text-bodymd text-textPrimary", className)}
      aria-invalid={!isValid}
      data-show-validation={shouldShowValidation}
    >
      {children}
    </label>
  );
}
